// @ts-nocheck
import React, { Component, PropTypes } from 'react'
import Title from 'react-title-component'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import spacing from 'material-ui/styles/spacing'
import { darkWhite, lightWhite, grey200 } from 'material-ui/styles/colors'
import NavDrawer from '../navDrawer'
import FullWidthSection from '../FullWidthSection'
import withWidth, { MEDIUM, LARGE } from 'material-ui/utils/withWidth'

class Layout extends Component<any, any> {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object,
    width: PropTypes.number.isRequired
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    muiTheme: PropTypes.object.isRequired
  }

  state = {
    navDrawerOpen: false
  }

  getStyles () {
    const styles = {
      appBar: {
        position: 'fixed',
        top: 0,
        zIndex: 10
      },
      root: {
        paddingTop: spacing.desktopKeylineIncrement,
        minHeight: 400
      },
      content: {
        margin: spacing.desktopGutterLess
      },
      contentWhenMedium: {
        margin: `${spacing.desktopGutterLess * 2}px ${spacing.desktopGutterLess * 3}px`
      },
      footer: {
        backgroundColor: grey200,
        textAlign: 'center'
      },
      a: {
        color: darkWhite
      },
      p: {
        margin: '0 auto',
        padding: 0,
        color: lightWhite,
        display: 'inline-block'
      },
      browserstack: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        margin: '25px 15px 0',
        padding: 0,
        color: lightWhite,
        lineHeight: '25px',
        fontSize: 12
      },
      svgLogo: {
        width: '200px',
        margin: 0
      },
      iconButton: {
        color: darkWhite
      }
    }

    if (this.props.width === MEDIUM || this.props.width === LARGE) {
      styles.content = Object.assign(styles.content, styles.contentWhenMedium)
    }

    return styles
  }

  handleTouchTapLeftIconButton = () => {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen
    })
  }

  handleChangeRequestNavDrawer = (open) => {
    this.setState({
      navDrawerOpen: open
    })
  }

  handleChangeList = (event, value) => {
    if (value) {
      this.setState({
        navDrawerOpen: false
      })
      this.context.router.push(value)
    }
  }

  render () {
    const {
      location,
      children
    } = this.props

    let {
      navDrawerOpen
    } = this.state

    const {
      prepareStyles
    } = this.context.muiTheme

    const router = this.context.router
    const styles = this.getStyles()

    let docked = false
    let showMenuIconButton = true

    const isDashboard = router.isActive('/', true)

    if (this.props.width === LARGE && !isDashboard) {
      docked = true
      navDrawerOpen = true
      showMenuIconButton = false

// @ts-ignore
      styles.navDrawer = {
        zIndex: styles.appBar.zIndex - 1
      }
// @ts-ignore
      styles.root.paddingLeft = 256
// @ts-ignore
      styles.footer.marginLeft = 256
    }

    const title = 'NCFDD Admin'

    return (
      <div>
        <Title render={title} />
        <AppBar
          onLeftIconButtonClick={this.handleTouchTapLeftIconButton}
          title=''
          zDepth={0}
          iconElementRight={
            <IconButton
              iconClassName='muidocs-icon-custom-github'
              href='https://github.com/twg/ncfdd'
            />
          }
          style={styles.appBar}
          showMenuIconButton={showMenuIconButton}
        />
        <NavDrawer
// @ts-ignore
          style={styles.navDrawer}
          location={location}
          docked={docked}
          onRequestChangeNavDrawer={this.handleChangeRequestNavDrawer}
          onChangeList={this.handleChangeList}
          open={navDrawerOpen}
        />

        {isDashboard
          ? children
          : <div style={prepareStyles(styles.root)}>
            <div style={prepareStyles(styles.content)}>
              {React.cloneElement(children, {
                // @ts-ignore
                onChangeMuiTheme: this.handleChangeMuiTheme
              })}
            </div>
          </div>}

        <FullWidthSection style={styles.footer}>
          <p style={prepareStyles(styles.p)}>
            <a href='http://www.ncfdd.org/' target='_blank' rel="noreferrer"><img style={styles.svgLogo} src='/images/ncfddLogo.png' /></a>
          </p>
        </FullWidthSection>
      </div>
    )
  }
}

export default withWidth()(Layout)
